import { getIncodeClient } from '@egw/risk-service'
import { Logger } from '@egw/logger'
import { type FC, useEffect, useRef } from 'react'

const log = new Logger('DocV')

interface FrontIdProps {
  session: { token: string }
  onSuccess: (result: any) => void
  onError?: (error: any) => void
}

export const FrontId: FC<FrontIdProps> = ({ session, onSuccess, onError }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const isMounted = useRef(false)

  log.info('FrontId: Starting camera render')

  useEffect(() => {
    if (isMounted.current || !session || !containerRef.current) {
      return
    }

    getIncodeClient().renderCamera('front', containerRef.current, {
      onSuccess: (result) => {
        onSuccess(result)
      },
      onError: (error) => {
        log.error('FrontId: Error during camera rendering', error)
        if (onError) {
          onError(error)
        }
      },
      token: session,
      numberOfTries: -1,
      showTutorial: true,
      fullScreen: false,
    })

    isMounted.current = true
  }, [onSuccess, onError, session])

  return <div ref={containerRef} className="w-full" style={{ background: '#fff !important' }} />
}
